module.exports = __webpack_public_path__ + "img/icon_circle.7e3a6463.png";